import axios from 'axios'
import Cookies from 'js-cookie'
import { useAuthStore } from '@/lib/stores/authStore'
import { redirectToLogin } from '@/lib/utils/script'
import { getTimezone } from '@/lib/utils/timezone'

const baseURL = process.env.NEXT_PUBLIC_API_URL || ''

export const api = axios.create({ baseURL })

// 동시성 제어: refresh 요청은 한 번만 날리고, 나머지는 해당 Promise를 기다리게 함
let refreshRequest: Promise<{ access: string; refresh: string }> | null = null

async function getOrRequestTokenRefresh() {
  if (!refreshRequest) {
    const currentRefreshToken = Cookies.get('axp_refresh_token')
    refreshRequest = axios
      .post(`${baseURL}/front/v1/auth/users/token`, {
        refresh_token: currentRefreshToken,
      })
      .then(({ data }) => {
        const newAccess = data.data.access_token
        const newRefresh = data.data.refresh_token

        Cookies.set('axp_access_token', newAccess)
        Cookies.set('axp_refresh_token', newRefresh)

        useAuthStore.getState().setTokens(newAccess, newRefresh)
        // 향후 요청 기본 Authorization 헤더도 최신화(선제적으로 세팅)
        api.defaults.headers.Authorization = `Bearer ${newAccess}`

        return { access: newAccess, refresh: newRefresh }
      })
      .finally(() => {
        refreshRequest = null
      })
  }
  return refreshRequest
}

// 토큰 추가 인터셉터
api.interceptors.request.use(
  config => {
    const token = Cookies.get('axp_access_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    const timezone = getTimezone()
    if (timezone) (config.headers as any)['X-Timezone'] = timezone
    return config
  },
  error => Promise.reject(error),
)

// 응답 인터셉터 - 토큰 만료 시 재발급 시도
api.interceptors.response.use(
  res => res,
  async error => {
    const originalRequest = error.config
    console.log('error', error)

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const { access } = await getOrRequestTokenRefresh()
        originalRequest.headers.Authorization = `Bearer ${access}`
        return api(originalRequest)
      } catch (err) {
        useAuthStore.getState().clearTokens()
        redirectToLogin()
      }
    } else if (error.response?.status === 403) {
      const errorData = error.response?.data?.error
      switch (errorData.code) {
        case 'ERR-2011': {
          const resetToken = errorData.data.reset_token
          const resetUrl = `/login/reset-password?token=${resetToken}`
          window.location.href = resetUrl
          break
        }
        default: {
        }
      }
    }

    return Promise.reject(error)
  },
)
